<template>
  <v-dialog v-model="is_show" hide-overlay persistent :width="width">
    <v-card :color="hint_color" dark>
      <v-card-text class="pt-4">
        {{ message }}
        <v-progress-linear v-if="value === 0" indeterminate :color="progress_color" class="mb-0" />
        <v-progress-linear v-else :value="value" :color="progress_color" class="mb-0" />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'VProgress',
  data() {
    return {
      is_show: false,
      width: 300,
      message: '',
      hint_color: 'primary',
      progress_color: 'white',
      timeout: 2000,
      value: 0,
    }
  },
  methods: {
    init(data) {
      this.message = data.message || 'missing "message".'
      this.hint_color = data.hint_color || this.hint_color
      this.progress_color = data.progress_color || this.progress_color
      this.width = data.width || this.width
      this.value = data.value || 0
    },
    show() {
      this.is_show = true
    },
    setValue(value) {
      this.value = value
    },
    setText(text) {
      this.message = text
    },
    hide() {
      this.is_show = false
    },
  },
}
</script>
